export const PROVIDER_CONSTANTS = {
  buildStepService: 'buildStepService',
  buildTypeService: 'buildTypeService',
  caliberService: 'caliberService',
  cartridgeService: 'cartridgeService',
  contactService: 'contactService',
  customerOrderService: 'customerOrderService',
  customerQuoteService: 'customerQuoteService',
  customerService: 'customerService',
  dashboardInformationService: 'dashboardInformationService',
  inventoryItemService: 'inventoryItemService',
  inventoryTypeFieldService: 'inventoryTypeFieldService',
  inventoryTypeService: 'inventoryTypeService',
  manufacturerService: 'manufacturerService',
  miscellaneousService: 'miscellaneousService',
  noteService: 'noteService',
  orderBuildStepService: 'orderBuildStepService',
  orderPartService: 'orderPartService',
  orderService: 'orderService',
  orderServiceService: 'orderServiceService',
  purchaseOrderItemService: 'purchaseOrderItemService',
  purchaseOrderService: 'purchaseOrderService',
  quotePartService: 'quotePartService',
  quoteService: 'quoteService',
  quoteServiceService: 'quoteServiceService',
  roleService: 'roleService',
  serviceFieldService: 'serviceFieldService',
  serviceService: 'serviceService',
  stateService: 'stateService',
  supplierService: 'supplierService',
  userService: 'userService',
  toaster: 'toaster'
}
